import React from "react";
import { TextField, Typography, Grid, } from "@mui/material";
import MappedText from "../../reports/create-report/shared-components/mapText";



export default function Observations({
    sampleQualityObservations,
    sequencingQualityObservations,
    handleInputChange
  }) {
    return (
      <>
        <Typography variant={"h5"} style={{ fontWeight: "700", marginBottom: "20px" }}>
          <MappedText text={"Relevant Observations"} />
        </Typography>
        <Grid container spacing={2} sx={{ marginBottom: 4 }}>
          <Grid item xs={12} sm={6} md={6}>
            <TextField
              fullWidth
              id="standard-multiline-static"
              label={<MappedText text={"Sample quality observations"} />}
              multiline
              rows={4}
              name="sampleQualityObservations"
              value={sampleQualityObservations}
              onChange={handleInputChange}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={6}>
            <TextField
              fullWidth
              id="standard-multiline-static"
              label={<MappedText text={"Sequencing quality observations"} />}
              multiline
              rows={4}
              name="sequencingQualityObservations"
              value={sequencingQualityObservations}
              onChange={handleInputChange}
            />
          </Grid>
        </Grid>
      </>
    );
  }